import styled from 'styled-components';

export const StyledCheckboxList = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
`;
